import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Login, { ISkin } from '../../views/login/Login'
import { ICharacterData } from '../../helpers/data/characterData'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import viewSelector from '../../redux/selectors/login/viewSelector'

import loginActions from '../../redux/actions/loginActions'
import withTransition from '../../hoc/Transition'
import withResizer from '../../hoc/Resizer'
import { IStore } from '../../redux/reducers/index'

interface ICharactersProps {
	characterSelected: (id: string) => void
	characters: ICharacterData[]
	skin: ISkin
	deviceUid: string
}

class LoginConnector extends PureComponent<ICharactersProps> {
	render() {
		return (
			<Login
				characterSelected={this.props.characterSelected}
				characters={this.props.characters}
				skin={this.props.skin}
				deviceUid={this.props.deviceUid}
			/>
		)
	}
}
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			characterSelected: loginActions.characterSelected,
		},
		dispatch
	)
}

const mapStateToProps = (state: IStore) => {
	return viewSelector(state)
}

export default withTransition(withResizer(connect(mapStateToProps, mapDispatchToProps)(LoginConnector), 1024, 768))
